import React from 'react';
import styled from 'styled-components';

export const HowWe = () => {
  return (
    <Section>
      <WW>
        <Sub>How We Do It</Sub>
        <StepContainer>
          <Step>
            <Title>Phase 1: Planning</Title>
            <Desc>We start with an in-depth session to understand your business, identify challenges, and map out the best path to growth and efficiency.</Desc>
          </Step>
          <Step>
            <Title>Phase 2: Growth</Title>
            <Desc>We create a clear, results-driven plan to elevate your business, ensuring steady progress and long-term success.</Desc>
          </Step>
          <Step>
            <Title>Phase 3: Execution</Title>
            <Desc>The future becomes reality—quickly and seamlessly. You stay ahead, leaving the competition behind.</Desc>
          </Step>
        </StepContainer>

        <Sub>Why Choose Us?</Sub>
        <StepContainer>
          <Step>
            <Title>24/7 AI-Powered Voice Agents</Title>
            <Desc>Never miss a call again—our AI handles customer interactions round the clock.</Desc>
          </Step>
          <Step>
            <Title>Reduce Costs & Workload</Title>
            <Desc>Automate repetitive tasks, cut operational costs, and free up your team’s time.</Desc>
          </Step>
          <Step>
            <Title>Seamless Integration</Title>
            <Desc>Effortlessly connect with your existing systems, ensuring smooth operations.</Desc>
          </Step>
        </StepContainer>
      </WW>
    </Section>
  );
};

// Styled Components

const Section = styled.section`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 40px 20px;
  margin-top: 5%;
`;

const WW = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 30px;
  padding: 40px 20px;
  justify-content: center;
  background: linear-gradient(135deg, #e96443, #26D0CE);
  border-radius: 24px;
  width: 100%;
  max-width: 1200px;
`;

const Sub = styled.h2`
  font-family: 'Clash Grotesk', sans-serif;
  font-style: normal;
  color: #eef1da;
  font-size: 32px;
  font-weight: 500;
  text-align: center;
  margin: 0;
`;

const StepContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 20px;
  width: 100%;
  max-width: 1200px;

  @media (max-width: 1024px) {
    grid-template-columns: repeat(2, 1fr);
  }

  @media (max-width: 768px) {
    grid-template-columns: repeat(1, 1fr);
  }
`;

const Step = styled.div`
  background-color: #04646c;
  padding: 20px;
  border-radius: 16px;
  text-align: center;
  transition: transform 0.3s ease-in-out;

  &:hover {
    transform: scale(1.05);
  }
`;

const Title = styled.h1`
  font-family: 'Clash Grotesk', sans-serif;
  font-style: normal;
  font-weight: 500;
  color: #eef1da;
  font-size: 22px;
`;

const Desc = styled.p`
  font-family: raritas, sans-serif;
  font-style: normal;
  font-weight: 400;
  color: #eef1da;
  font-size: 18px;
  text-wrap: wrap;
`;
